const formatEmailInput = (value) => {

  return value;

  if (value) {
    if (value === "")
      return value;

    let t=0;
    value = value.replace(/@/g, function (match) {
      t++;
      return (t === 2) ? "" : match;
    });

    if (value.includes("@"))
      if (value.includes(".") && value.indexOf(".") > value.indexOf("@"))
        return value;
      else if (value.indexOf("@") < value.length - 1)
        return value + ".";
      else
        return value;
    else {
      if (value.includes(".") && value.indexOf(".") === value.length - 1)
        return value.substr(0, value.indexOf(".")) + "@";
      else
        return value + "@";
    }
  }

  return value;
}

const validateEmail = (email) =>
{
  if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email))
    return (true);
  return (false)
}


export {
  formatEmailInput,
  validateEmail
}